export default __webpack_public_path__ + "static/media/Orange and Beige Illustration Wicked Cute Halloween Circle Sticker.2e0300e1.jpg";